<template>
  <v-app class="t2d-app">
    <div class="layout">
      <AppHeader v-if="!hideAppBar"></AppHeader>
      <v-main class="layout-main">
        <router-view :key="$route.fullPath" />
      </v-main>
      <ShareBar v-if="!hideAppBar"></ShareBar>
      <Footer v-if="!hideAppBar"></Footer>
    </div>
    <CookieBanner></CookieBanner>
  </v-app>
</template>

<script>
import AppHeader from "@/components/shell/AppHeader";
import ShareBar from "@/components/shell/ShareBar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
export default {
  computed: {
    // ?hide_app_bar=true: the page is embedded (e.g. in the website), so no
    // header, share bar or footer
    hideAppBar() {
      return this.$route.query.hide_app_bar === "true";
    },
  },
  components: {
    AppHeader,
    ShareBar,
    Footer,
    CookieBanner,
  },
};
</script>

<style scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-main {
  flex: 1 0 auto;
}
</style>
